
import { useEffect } from 'react';

import { Responsive, scrollTop } from '@share/utils';
import { CarsDetailsWrapper } from '@components';

import './style.scss';

export function CarsDetailPage(props: { isStripe?: boolean }) {
  useEffect(() => {
    scrollTop();
  },[]);

  return (
    <div className="cars-details-page">
      <Responsive>
        <CarsDetailsWrapper isStripe={!!props.isStripe} />
      </Responsive>
    </div>
  );
}
